import { useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import { useTranslation } from "react-i18next";
import * as Actions from "../../store/actions/global/global";
import cautionIcon from "../../assets/icons/caution-diamond.png";
import { FlexColumn, Img, TitleWrapper, BodyWrapper } from "../../constants/common/StyledGlobalConstants";
import PropTypes from "prop-types";

const PlannedMaintenance = (props) => {
  const [maintenanceData, setMaintenanceData] = useState({});
  const remainingTime = 3600000; // 60 minutes
  const { t } = useTranslation("loginTranslation");

  useEffect(() => {
    setMaintenanceData(props.plannedMaintenance);

    let endTime = props.plannedMaintenance.endTime;
    let end = convertUTCDateToLocalDate(endTime);
    let current = currentDateTimeInLocalTime();
    let ms = moment(end, "DD-MM-YYYY HH:mm:ss").diff(moment(current, "DD-MM-YYYY HH:mm:ss"));
    let duration = moment.duration(ms).asMilliseconds();

    if (duration <= remainingTime) {
      //end Planned Maintenance page
      setTimeout(function () {
        props.setDisplayPlannedMaintenance(false);
      }, duration);
    }
  }, [props.plannedMaintenance]);

  const convertUTCDateToLocalDate = (date) => {
    const dates = moment(date).utc().format();
    const locals = moment.utc(dates).local().format();
    return locals;
  };
  const currentDateTimeInLocalTime = () => {
    const date = moment.utc().format();
    const local = moment.utc(date).local().format();
    return local;
  };

  const compareDate = (startTime, endTime) => {
    let first = moment(startTime);
    let second = moment(endTime);
    let duration = second.diff(first, "hours");
    let hoursDiff;

    if (duration < 24) {
      hoursDiff = true;
    } else {
      hoursDiff = false;
    }
    return hoursDiff;
  };

  const formatDate = (date) => {
    const dates = moment(date).utc().format();
    const locals = moment.utc(dates).local().format("dddd MMMM D, YYYY; h:mm A");
    return locals;
  };

  const timeZone = () => {
    let value = momentTimeZone().tz(moment.tz.guess()).format("z");
    return value;
  };
  return (
    <FlexColumn justifyContent="center" alignItems="center" style={{ margin: "10% auto" }} aria-label="Planned maintenance in Progress">
      <Img width="1.7rem" height="1.7rem" src={cautionIcon} alt="cautionMark" />
      <TitleWrapper size="medium" marginTop="0.5rem">
        {t("Planned maintenance in progress")}
      </TitleWrapper>
      <BodyWrapper marginTop="0.4rem">
        {`${
          compareDate(maintenanceData.startTime, maintenanceData.endTime)
            ? formatDate(maintenanceData.startTime) + " to " + moment(maintenanceData.endTime).utc().local().format("h:mm A ") + timeZone() + "."
            : formatDate(maintenanceData.startTime) +
              " to " +
              moment(maintenanceData.endTime).utc().local().format("dddd MMMM D, h:mm A ") +
              timeZone() +
              "."
        }
								`}
      </BodyWrapper>
      <BodyWrapper marginTop="0.3rem">{t("Try again later.")}</BodyWrapper>
    </FlexColumn>
  );
};

const mapStateToProps = (state) => {
  return {
    bannerMessage: state.ACCOUNT.bannerMessage,
    plannedMaintenance: state.ACCOUNT.plannedMaintenance,
  };
};

const mapDispatchToProps = {
  setBannerDisplayOnLanding: Actions.setBannerDisplayOnLanding,
  setBannerDisplayOnAll: Actions.setBannerDisplayOnAll,
  getPlannedMaintenance: Actions.getPlannedMaintenance,
  setDisplayPlannedMaintenance: Actions.setDisplayPlannedMaintenance,
};

PlannedMaintenance.propTypes = {
  plannedMaintenance: PropTypes.object.isRequired,
  setDisplayPlannedMaintenance: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlannedMaintenance);